require("@babel/polyfill/noConflict");
require("./media-motive.scss");
require("./impression-tracker");

(function ($, postscribe, kruxSasHelper, scriptUrl, global) {
    const getRandomNumber = () => {
        const min = 1000000000;
        const max = 9999999999;
        return Math.floor(Math.random() * (max - min + 1) + min);
    };

    const getViewId = () => {
        global.mm_advert_view_id = global.mm_advert_view_id || getRandomNumber();

        return global.mm_advert_view_id;
    };

    const trimEnd = (value, charToTrim) => {
        if (!value || !`${value}`.endsWith(charToTrim)) return value;

        return value.slice(0, charToTrim.length * -1);
    };

    const trimStart = (value, charToTrim) => {
        if (!value || typeof value !== 'string') return value;
        let minLength = value.length > charToTrim.length ? charToTrim.length : value.length;
        if (value.substring(0, minLength) == charToTrim)
            return value.substring(minLength, value.length);
        return value;
    };

    const getKruxTags = () => {
        if (kruxSasHelper) {
            return [
                { key: "", value: kruxSasHelper().getSasTags() },
                { key: "", value: kruxSasHelper().getGaTags() }
            ];
        }

        console.warn("KruxSasHelper not loaded");
        return [];
    };

    const getReplaceTags = (elm) => {
        return Object.keys($(elm).data())
            .filter(k => k.startsWith("adReplace"))
            .map(k => ({ key: k.replace("adReplace", "").toLowerCase(), value: $(elm).data()[k] }));
    };

    const getOtherTags = (elm) => {
        return [
            { key: "tile", value: $(elm).data("adTile") },
            { key: "viewid", value: getViewId() },
            { key: "random", value: getRandomNumber() }
        ];
    };

    const getTags = (elm) => {
        return getOtherTags(elm)
            .concat(getKruxTags())
            .concat(getReplaceTags(elm));
    };

    const replaceTags = (url, tags) => {
        let newUrl = url + "/";

        tags.filter(x => x.value !== "")
            .forEach(tag => {
                let value = trimStart(tag.value, "/");
                if (tag.key === "") {
                    newUrl = trimEnd(newUrl, "/") + `/${value}`;
                } else {
                    newUrl = newUrl.replace(new RegExp(`${tag.key}=.*?(\/|$)`, "gmi"), "");
                    newUrl = trimEnd(newUrl, "/") + `/${tag.key}=${value}`;
                }
            });

        return newUrl;
    };

    const loadAdvert = (tile) => {
        return new Promise((resolve, reject) => {
            const elm = $(`[data-ad-tile=${tile}]`);
            const tags = getTags(elm);
            const url = replaceTags(scriptUrl, tags);

            elm.empty();
            postscribe(elm,
                `<script src='${url}'><\/script>`,
                {
                    done: function () {
                        elm.css("background", "none");
                        resolve();
                    },
                    error: function (err) {
                        elm.empty();
                        reject({ url: url, error: err });
                    }
                });
        });
    };

    const reloadAd = (elm) => {
        const tile = elm.data("adTile");
        global.adReloadingForTile = global.adReloadingForTile || [];

        if (!global.adReloadingForTile[tile]) {
            global.adReloadingForTile[tile] = true;

            loadAdvert(tile)
                .catch(function (err) {
                    console.warn("MM: Error re-loading advert", err);
                })
                .finally(function () {
                    global.adReloadingForTile[tile] = false;
                });
        }
    };

    const scanAndLoadAdverts = () => {
        $("div[data-ad-tile]").each(function () {
            const elm = $(this);
            const loadAd = (elm.data("adSkipOnLoad") || "").toString().toLowerCase() !== "true";

            if (loadAd) {
                loadAdvert(elm.data("adTile"))
                    .catch(function(err) {
                        console.warn("MM: Error loading advert", err);
                    });
            }

            const reloadOn = elm.data("adReloadOn");
            if (reloadOn) {
                $(global).on(reloadOn, function () { reloadAd(elm); });
            }
        });
    };

    $(function () {
        scanAndLoadAdverts();
    });

    global.MMHelper = {
        loadAdvert: loadAdvert
    };

})(jQuery, postscribe, window.KruxSasHelper, media_motive_ad_script_url, window);